class SearchConfig {
    constructor(SearchService) {
        this.restrict = 'A';
        this.scope = {
            autocompleteUrl: '@searchUrl',
            minCharactersBeforeRequest: '@searchMinChars',
            waitTimeBeforeRequest: '@searchDelay'
        };
        this.searchService = SearchService;
        this.controller = function () {
            // set config for search
        }
    }

    // Directive link function
    link(scope, element, attrs) {
        this.searchService.autocompleteUrl = scope.autocompleteUrl;
        this.searchService.minCharactersBeforeRequest = scope.minCharactersBeforeRequest;
        this.searchService.waitTimeBeforeRequest = scope.waitTimeBeforeRequest;
    }
}

export default SearchConfig;

// https://www.michaelbromley.co.uk/blog/exploring-es6-classes-in-angularjs-1.x/
// https://blog.thoughtram.io/angularjs/2015/01/02/exploring-angular-1.3-bindToController.html
// https://stackoverflow.com/questions/15676614/link-vs-compile-vs-controller
